import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-filter-confirm-dialog",
    templateUrl: "./filter-confirm-dialog.component.html",
    styleUrl: "./filter-confirm-dialog.component.scss",
    standalone: false,
})
export class FilterConfirmDialogComponent {
    public presetFilterForm: FormGroup;
    public header: string = "Warning";
    public text: string = "Are you sure you want to delete this filter?";

    constructor(
        public dialogRef: MatDialogRef<FilterConfirmDialogComponent>,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            delete: boolean;
            presetFilterName?: string;
        },
    ) {
        this.presetFilterForm = this._formBuilder.group({
            filterName: [this.data.presetFilterName ? this.data.presetFilterName : "", Validators.required],
        });

        if (!this.data.delete) {
            this.text = "Are you sure you want to overwrite this filter?";
        }

        if (!this.data.presetFilterName) {
            this.header = "New Filter";
            this.text = "Please insert a name for the new filter:";
        }
    }

    public onDialogClose() {
        if (this.data.delete) {
            this.dialogRef.close(true);
        } else {
            if (this.presetFilterForm.valid) {
                this.dialogRef.close({ filterName: this.presetFilterForm.controls["filterName"].value });
            }
        }
    }
}
